import React, {useEffect, useState} from "react"
import {connect} from "react-redux";
import {withRouter} from "../../../helpers/withRouter";
import ViewerCP from "../report-viewer/ViewerCP";
import ReportCP from "./ReportCP";
import Header from "../../Panel/Header/header";
import Footer from "../../Panel/Footer/footer";
import Study from '../../../core/api/Study2/Study';
import NotFound from "../../404/NotFound";
import snippets from "../../../helpers/snippets";
import Storage from "../../../helpers/Storage";
import {default as _} from "../../../helpers/Translate"

const study = new Study()

const ReportOrViewer = (props) => {
    const [language] = useState(props.language)
    const [data, setData] = useState(props.data)
    const [repID, setRepID] = useState(props.params.reportID)
    const [whichOne, setWhichOne] = useState(null)

    useEffect(()=>{
    },[])

    useEffect(()=>{
        handleSendRequest(props.parentComp, props.data)
    }, [props.parentComp, props.data])

    useEffect(() => {
        if (props.parentComp === "report" && data && !snippets.isObjectEmpty(data?.study?.reports)) {
            document.title = _.init4("title_reportPage", {patient: data.patient?.his_full_name}, language)}
    }, [data]);

    useEffect(()=>{
        setWhichOne(findStatus(data?.study?.reports, repID))
        Storage.addNewVisitedRowIDs(data?.study?.id, repID)
    },[data, repID])

    useEffect(()=>{
    },[whichOne])

    const reqOnServer = () => {
        return study.studyInfoForReport(props.params.studyID, null, true).then(response => {
            setWhichOne("")
            return (response.data)
        }).catch(()=>{
            setWhichOne("notFound")
        })
    }

    const handleSendRequest = (parentComp, data) => {
        switch (parentComp) {
            case "report":
                reqOnServer().then((e)=>{setData(e)})
                break;
            case "split_viewer":
                setData(data)
                break;
            default:
                console.error("Who loads this!")
        }
    }

    const findStatus = (reports, id) => {
        if (reports && id in reports){
            switch (reports[id]?.can_edit){
                case true:
                    return "report"
                case false:
                    return "viewer"
                default:
                    return ""
            }
        } else if (!snippets.isObjectEmpty(data) && !snippets.isObjectEmpty(reports)){
            let newID = Object.keys(reports)[0]
            setRepID(newID)
            return findStatus(reports, newID)
        } else if (!snippets.isObjectEmpty(data) && snippets.isObjectEmpty(reports)) {
            return "notFound"
        }
    }

    const returnsViewer = () => {
        return <>
            <ViewerCP data={Object.assign({},
                {study: data?.study},
                {patient: data?.patient},
                {reportID: repID}
                        )}
            />
        </>
    }

    const handleServerRes = (currentID, res) =>{
        let obj = {...data}
        if (currentID === "-1") console.error("how it gonna happen")
        else if (currentID === "0" && res.id !== null) {
            setRepID(res.id)
            delete obj.study.reports[0]
            obj.study.reports[res.id]={...res}
        } else {
            obj.study.reports[currentID]={...res}
        }
        Storage.removeNewStudyReportWholes(res.study_id, currentID)
        setData(obj)
    }

    const changeReportID = (id) => {
        if (id in data.study.reports){
            setRepID(id)
        } else {
            reqOnServer().then((e)=>{
                setRepID(id)
                setData(e)
            })
        }
    }

    const returnsReport = () => {
        return <>
            <ReportCP data={Object.assign({},
                            {...data},
                            {reportID: repID})
                        }
                      handleChangeReport={(id)=> changeReportID(id)}
                      serverRespond={handleServerRes}
            />
        </>
    }

    const afterLogin = () => {
        handleSendRequest(props.parentComp, props?.data)
    }

    return <>
            <Header page={props.parentComp}
                    closeOrFullScreen={props.closeOrFullScreen}
                    afterLogin={afterLogin}
            />
            <div className={"report_page"}>
                {whichOne === "viewer" ? returnsViewer() : whichOne === "report" ? returnsReport() : whichOne === "notFound" ? <NotFound headerFooter={false}/> : ""}
            </div>
            <Footer />
        </>
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return { language };
};

export default connect(mapStateToProps)(withRouter(ReportOrViewer));